<template>
    <div class="overflow-hidden text-white py-lg-3 tyre-finder-bg col-12">
        <div class="tyre-finder-header container">
            <div class="row flex-wrap justify-content-center justify-content-lg-between">
                <div class="tyre-finder-tabs-container col-12 col-lg-6 d-flex flex-wrap align-items-end justify-content-center justify-content-sm-start">
                    <h4 class="mr-3 mr-sm-5 search-heading">SEARCH<span class="d-none d-sm-inline"> TYRES</span> BY</h4>
                    <ul class="nav nav-pills d-flex flex-nowrap" id="TyreFinderTabs" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link px-1 px-sm-2 active" id="tyre-tab" data-toggle="tab" href="#tyre" role="tab" aria-controls="tyre" aria-selected="false" tabindex="1" @click="displayTyreResults(false); clearVehicle();">
                                <span class="h5">Size</span>
                            </a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link px-1 px-sm-2" id="vehicle-tab" data-toggle="tab" href="#vehicle" role="tab" aria-controls="vehicle" aria-selected="true" tabindex="1">
                                <span class="h5">Vehicle</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="tyre-size-help mt-3 mt-lg-0 col-12 col-lg-6 d-flex align-items-center justify-content-center justify-content-sm-start justify-content-lg-end">
                    <a data-toggle="modal" data-target="#tyrediagram" style="cursor: pointer"><span class="mr-1">&#9432;</span><small><i>Need help with your tyre size?</i></small></a>
                </div>
            </div>
        </div>
        <div class="tab-content container" id="TyreFinderForm">
            <div class="tab-pane show active" id="tyre" role="tabpanel" aria-labelledby="tyre-tab">
                <div class="tyre-finder-wrapper">
                    <div class="tyre-finder-main-form">
                        <div class="row">
                            <div class="form-group by-size-selector col-12 col-sm-6 col-md-4 col-lg">
                                <select class="form-control rounded-0" id="section-width"
                                        v-model="SectionWidth"
                                        @change="clearTyreFinderInput('aspect-ratio'); AspectRatio = '';
                            clearTyreFinderInput('rim-size'); RimSize = '';">

                                    <option value="" selected disabled>Section Width</option>

                                    <option v-for="(section, index) in getUniqueSectionWidth" :key="section + index"
                                            v-bind:value="sectionBind(section)" v-bind:disabled="isSectionLabel(section)">
                                        {{sectionDisplay(section)}}
                                    </option>

                                </select>
                            </div>

                            <div class="form-group by-size-selector col-12 col-sm-6 col-md-4 col-lg">
                                <select class="form-control rounded-0" id="aspect-ratio"
                                        v-model="AspectRatio"
                                        v-bind:disabled="SectionWidth==''"
                                        @change="clearTyreFinderInput('rim-size'); RimSize = '';">

                                    <option value="" selected disabled>Aspect Ratio</option>

                                    <option v-for="ratio in getAspectRatio" :key="ratio"
                                            v-bind:value="ratio * 1">
                                        {{ratio * 1}}
                                    </option>

                                </select>
                            </div>

                            <div class="form-group by-size-selector col-12 col-sm-6 col-md-4 col-lg">
                                <select class="form-control rounded-0" id="rim-size"
                                        v-model="RimSize"
                                        v-bind:disabled="AspectRatio==''"
                                        @change="getTyreFinderSAR">

                                    <option value="" selected disabled>Rim Size</option>

                                    <option v-for="size in getRimSize" :key="size"
                                            v-bind:value="size * 1">
                                        {{size * 1}} "
                                    </option>

                                </select>
                            </div>

                            <div class="tyre-finder-tyre-validation">
                                <p>&nbsp;</p>
                            </div>
                            <div class="by-size-find-tyres d-flex mt-2 mt-lg-0 col-12 col-lg flex-wrap justify-content-center justify-content-md-start justify-content-lg-end">
                                <div class="form-group d-flex justify-content-center  justify-content-lg-end">
                                    <a target="_top" :class="['btn btn-yellow btn-hover-yellow text-uppercase rounded-0 chevron-right-icon', { 'disabled' : RimSize=='' }]"
                                       :href="TyreFinderSAR" onclick="parent.dataLayer.push({'event':'FindTyresBySize'});">
                                        Find Tyres
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane" id="vehicle" role="tabpanel" aria-labelledby="vehicle-tab">
                <div class="tyre-finder-wrapper">
                    <div class="tyre-finder-main-form">
                        <div class="row">
                            <div class="form-group col-12 col-sm-6 col-md-3 col-lg by-vehicle-selector">
                                <select class="form-control rounded-0" id="vehicle-manufacturer"
                                        v-model="VehicleManufacturer"
                                        @change="fetchModel">

                                    <option value="" selected disabled>Manufacturer</option>

                                    <option v-for="vehicles in arrayMakes" :key="vehicles.slug"
                                            v-bind:value="vehicles.slug">
                                        {{vehicles.name}}
                                    </option>

                                </select>
                            </div>

                            <div class="form-group col-12 col-sm-6 col-md-3 col-lg by-vehicle-selector">
                                <select class="form-control rounded-0" id="vehicle-model"
                                        v-model="VehicleModel"
                                        v-bind:disabled="VehicleManufacturer==''"
                                        @change="fetchYear">

                                    <option value="" selected
                                            disabled>
                                        Model
                                    </option>

                                    <option v-for="model in arrayModels" :key="model.slug"
                                            v-bind:value="model.slug">
                                        {{model.name}}
                                    </option>

                                </select>
                            </div>

                            <div class="form-group col-12 col-sm-6 col-md-3 col-lg by-vehicle-selector">
                                <select class="form-control rounded-0" id="make-year"
                                        v-model="MakeYear"
                                        v-bind:disabled="VehicleModel==''"
                                        @change="fetchSpecification">

                                    <option value="" selected
                                            disabled>
                                        Make Year
                                    </option>

                                    <option v-for="year in arrayYears" :key="year.slug"
                                            v-bind:value="year.slug">
                                        {{year.name}}
                                    </option>

                                </select>
                            </div>

                            <div class="form-group col-12 col-sm-6 col-md-3 col-lg by-vehicle-selector">
                                <select class="form-control rounded-0" id="vehicle-specification"
                                        v-model="VehicleSpecification"
                                        v-bind:disabled="MakeYear==''"
                                        @change="getTyreFinderVehicles">

                                    <option value="" selected
                                            disabled>
                                        Specification
                                    </option>

                                    <option v-for="specs in arrayVariants" :key="specs.slug"
                                            v-bind:value="specs.slug">
                                        {{specs.fullname}}
                                    </option>
                                </select>
                            </div>

                            <div class="tyre-finder-vehicle-validation">
                                <p>&nbsp;</p>
                            </div>
                            <div v-if="arrayVehicleSizes.length == 1" class="form-group mt-2 mt-lg-0 d-flex col-12 col-lg by-vehicle-find-tyres justify-content-center justify-content-md-start justify-content-lg-end">
                                <a target="_top" :class="['btn btn-yellow btn-hover-yellow text-uppercase rounded-0 chevron-right-icon justify-content-center justify-content-lg-end', { 'disabled' : TyreFinderVehicles == '' }]"
                                :href="TyreFinderVehicles" onclick="parent.dataLayer.push({'event':'FindTyresByVehicle'});">
                                    Find Tyres
                                </a>
                            </div>
                            <div v-else-if="arrayVehicleSizes.length > 1" class="form-group mb-0 col-12">
                                <div>Your tyre size is one of the following:</div>
                                <a class="btn btn-sm btn-yellow btn-hover-yellow my-1 mx-2" v-for="(tyre, index) in arrayVehicleSizes" :href="formatC2FUrl(tyre)" :key="`size-${index}`" target="_top" onclick="parent.dataLayer.push({'event':'FindTyresByVehicle'});">
                                    {{ tyre.section }}/{{ tyre.aspect }}R{{ tyre.rim }}
                                </a>
                                <div>select one of the sizes above to search for your tyres</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    const Enumerable = require('linq')

    import gql from 'graphql-tag';

    export default {
        data() {
            return {
                tyreDataVehicles: null,
                tyreDataSAR: null,
                arraySAR: [],
                arrayMakes: [],
                arrayModels: [],
                arrayYears: [],
                arrayVariants: [],
                arrayVehicleSizes: [],
                VehicleManufacturer: '',
                VehicleModel: '',
                VehicleSpecification: '',
                MakeYear: '',
                VehicleInfo: '',
                SectionWidth: '',
                AspectRatio: '',
                RimSize: '',
                TyreFinderVehicles: '',
                TyreFinderSAR: '',
            }
        },
        mounted() {
            this.vehicleDataBind('get-quicktyre-vehicle-manufacturers')
                .then(data => {
                    this.arrayMakes = data;
                })
                .catch(() => {
                    this.arrayMakes = [];
                });
        },
        methods: {
            clearVehicleSizes() {
                this.TyreFinderVehicles = "";
                this.arrayVehicleSizes = [];
                this.displayTyreResults(false);
            },
            getTyreFinderVehicles() {
                this.arrayVehicleSizes = [];
                this.TyreFinderVehicles = "";
                this.vehicleDataBind(`get-quicktyre-vehicle-tyredetails?make=${this.VehicleManufacturer}&model=${this.VehicleModel}&year=${this.MakeYear}&id=${this.VehicleSpecification}`)
                    .then(data => {
                        this.arrayVehicleSizes = data;

                        if (this.arrayVehicleSizes.length == 1) {
                            this.TyreFinderVehicles = this.formatC2FUrl(this.arrayVehicleSizes[0]);
                        }

                        if (this.arrayVehicleSizes.length > 1) {
                            this.displayTyreResults(true);
                        }
                        else {
                            this.displayTyreResults(false);
                        }
                    })
                    .catch(() => {
                        this.displayTyreResults(false);
                    });
            },
            displayTyreResults(display = true) {
                var tyreResults = document.getElementById('TyreFinder');
                if (display) {
                    tyreResults.classList.add('vehicle-multiple-results');
                }
                else {
                    tyreResults.classList.remove('vehicle-multiple-results');
                }
            },
            getTyreFinderSAR() {
                this.TyreFinderSAR = "/click-2-fit/";
                this.TyreFinderSAR += this.SectionWidth
                    + "-" + this.AspectRatio
                    + "-R" + (this.RimSize + 0).toFixed(2);
            },
            clearTyreFinderInput(input) {
                var inputObject = document.getElementById(input);
                inputObject.selectedIndex = 0;
            },
            sectionBind(value) {
                //imperial sizes require two decimal places for C2F url purposes
                if (value * 1 > 0) {
                    if (value * 1 < 100) {
                        return value
                    }
                    else {
                        return value * 1
                    }
                }
                return ''
            },
            sectionDisplay(value) {
                if (value * 1 > 0) {
                    if (value * 1 < 100) {
                        return value
                    }
                    else {
                        return value * 1
                    }
                }
                return value.replace('__', '')
            },
            isSectionLabel(value) {
                if (value * 1 > 0) {
                    return false
                }
                return value.indexOf('__') > -1
            },
            clearModel() {
                this.clearTyreFinderInput('vehicle-model');
                this.VehicleModel = '';
                this.arrayModels = [];
            },
            fetchModel() {
                this.clearModel();
                this.clearYear();
                this.clearSpecification();
                this.clearVehicleSizes();

                this.vehicleDataBind(`get-quicktyre-vehicle-models?make=${this.VehicleManufacturer}`)
                    .then(data => {
                        this.arrayModels = data;
                    })
                    .catch(() => {
                        this.arrayModels = [];
                    });
            },
            clearYear() {
                this.clearTyreFinderInput('make-year');
                this.MakeYear = '';
                this.arrayYears = [];
            },
            fetchYear() {
                this.clearYear();
                this.clearSpecification();
                this.clearVehicleSizes();

                this.vehicleDataBind(`get-quicktyre-vehicle-years?make=${this.VehicleManufacturer}&model=${this.VehicleModel}`)
                    .then(data => {
                        this.arrayYears = data;
                    })
                    .catch(() => {
                        this.arrayYears = [];
                    });
            },
            clearSpecification() {
                this.clearTyreFinderInput('vehicle-specification');
                this.VehicleSpecification = '';
                this.arrayVariants = [];
            },
            fetchSpecification() {
                this.clearSpecification();
                this.clearVehicleSizes();

                this.vehicleDataBind(`get-quicktyre-vehicle-variants?make=${this.VehicleManufacturer}&model=${this.VehicleModel}&year=${this.MakeYear}`)
                    .then(data => {
                        this.arrayVariants = data;
                    })
                    .catch(() => {
                        this.arrayVariants = [];
                    });
            },
            clearVehicle() {
                this.clearTyreFinderInput('vehicle-manufacturer');
                this.VehicleManufacturer = '';
                this.clearModel();
                this.clearYear();
                this.clearSpecification();
                this.clearVehicleSizes();
            },
            async vehicleDataBind(path) {
                var url = `${this.getApiBaseUrl}/api/private/quicktyre/${path}`;
                return new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.open("GET", url);
                    xhr.setRequestHeader("x-surface", "public")
                    xhr.onload = () => {
                        const res = JSON.parse(xhr.responseText);
                        if ([200, 201, 204].includes(xhr.status)) {
                            resolve(res)
                        }
                        else {
                            reject([]);
                        }
                    };
                    xhr.onerror = () => {
                        reject([]);
                    };
                    xhr.send();
                });
            },
            formatC2FUrl(tyreSize) {
                return `/click-2-fit/${tyreSize.section}-${tyreSize.aspect}-R${tyreSize.rim.trim()}`;
            },
        },
        computed: {
            getSAR() {
                return JSON.parse(this.tyreDataSAR[0].json);
            },
            getUniqueSectionWidth() {
                let sectionWidth = Enumerable.from(this.arraySAR)
                    .select(s => s.s)
                    .distinct()
                    .orderBy(o => o)
                    .toArray();

                if (sectionWidth.length < 1) {
                    return sectionWidth;
                }

                sectionWidth.splice(0, 0, "__------------");
                sectionWidth.splice(0, 0, "__OD (imperial sizes)");

                for (let i = 0; i < sectionWidth.length; i++) {
                    if (sectionWidth[i] > 99) {
                        sectionWidth.splice(i, 0, "__------------");
                        sectionWidth.splice(i, 0, "__Section Width (metric  sizes)");
                        break;
                    }
                }

                return sectionWidth;
            },
            getAspectRatio() {
                return Enumerable.from(this.arraySAR)
                    .where(x => x.s == this.SectionWidth)
                    .select(s => s.a)
                    .distinct()
                    .orderBy(o => o)
                    .toArray();
            },
            getRimSize() {
                return Enumerable.from(this.arraySAR)
                    .where(x => x.s == this.SectionWidth && x.a == this.AspectRatio)
                    .select(s => s.r)
                    .distinct()
                    .orderBy(o => o)
                    .toArray();
            },
            IS_STAG() {
                return window.location.host.indexOf("inprogress") > -1 || window.location.host.indexOf("localhost") > -1;
            },
            getApiBaseUrl() {
                if (this.IS_STAG) return "https://mytyres.dunlop.nologostudios.net";

                return "https://api-admin.sumitomorubberportal.com";
            }
        },
        apollo: {
            tyreDataSAR: gql`
                    {
                      tyreDataSAR {
                        json
                      }
                    }
                `,
        },
        watch: {
            tyreDataSAR: {
                handler() {
                    this.arraySAR = this.getSAR;
                }
            }
        },
    };
</script>